import { Injectable } from '@angular/core';
import { NgZone } from '@angular/core';
import { AlertService } from '../../services/alert/alert.service';
import { AndroidPermissions } from '@ionic-native/android-permissions/ngx';
import { LocationAccuracy } from '@ionic-native/location-accuracy/ngx';
import { NativeGeocoder, NativeGeocoderResult, NativeGeocoderOptions } from '@ionic-native/native-geocoder/ngx';
import { Geolocation } from '@ionic-native/geolocation/ngx'; 
import { LoaderService } from '../../../app/services/loader/loader.service';
import { ApiService } from '../../services/api/api.service';
import { Platform  } from '@ionic/angular';
@Injectable({
  providedIn: 'root'
})
export class LocationService {
  latitude: any;
  longitude: any;
  address: any;
  options = {
    enableHighAccuracy : true,
    timeout: 15000,
    maximumAge: 0
  };

  constructor(
    private androidPermissions: AndroidPermissions,
    private geolocation: Geolocation,
    private locationAccuracy: LocationAccuracy,
    private nativeGeocoder: NativeGeocoder,
    public zone: NgZone,
    public alert: AlertService,
    public loader: LoaderService,
    public api : ApiService,
    private platform: Platform,
    ) { }


     //Check if application having GPS access permission  
  checkGPSPermission() {
    if (this.platform.is('hybrid')) {
      this.latitude = ''
      this.longitude = ''
      this.address = ''
      this.androidPermissions.checkPermission(this.androidPermissions.PERMISSION.ACCESS_COARSE_LOCATION).then(
        result => {
          if (result.hasPermission) {

            //If having permission show 'Turn On GPS' dialogue
            this.askToTurnOnGPS();
          } else {

            //If not having permission ask for permission
            this.requestGPSPermission();
          }
        },
        err => {
          alert(err);
        }
      );
    }
    else {
      if(localStorage.getItem('latitude') != undefined && localStorage.getItem('latitude') != null && localStorage.getItem('latitude') != ''){
        if(localStorage.getItem('longitude') != undefined && localStorage.getItem('longitude') != null && localStorage.getItem('longitude') != ''){
          this.getAddressFromCoords(localStorage.getItem('latitude'), localStorage.getItem('longitude'));
        }
      }
    }
  }

  requestGPSPermission() {
    this.locationAccuracy.canRequest().then((canRequest: boolean) => {
      if (canRequest) {
        console.log("4");
      } else {
        //Show 'GPS Permission Request' dialogue
        this.androidPermissions.requestPermission(this.androidPermissions.PERMISSION.ACCESS_COARSE_LOCATION)
          .then(
            () => {
              // call method to turn on GPS
              this.askToTurnOnGPS();
            },
            error => {
              //Show alert if user click on 'No Thanks'
              this.requestGPSPermission();
              // alert('requestPermission Error requesting location permissions ' + error)
            }
          );
      }
    });
  }


  askToTurnOnGPS() {
    this.locationAccuracy.request(this.locationAccuracy.REQUEST_PRIORITY_HIGH_ACCURACY).then(
      () => {
        // When GPS Turned ON call method to get Accurate location coordinates
        this.setCurrentLocation()
      },
      (error:any) =>{
        this.askToTurnOnGPS()
        // alert('Error requesting location permissions ' + JSON.stringify(error)
      })
  }

  

  // Get Current Location Coordinates
  setCurrentLocation() {
    this.loader.showLoader('Getting Current Location..')
    try {

      setTimeout(()=>{
        this.loader.hideLoader()
      },15000)

      this.geolocation.getCurrentPosition(this.options).then((resp:any) => {

        console.log(resp.coords.latitude,resp.coords.longitude)
        this.loader.hideLoader()
        this.latitude = resp.coords.latitude;
        this.longitude = resp.coords.longitude;
        this.api.setlatitude(this.latitude)
        this.api.setlongitude(this.longitude)
        
        //LOAD THE MAP WITH THE PREVIOUS VALUES AS PARAMETERS.
        this.getAddressFromCoords(resp.coords.latitude, resp.coords.longitude); 
  
      },(error) => {
        this.loader.hideLoader()
        console.log('Error getting location', error);
        this.alert.presentAlert('Alert','','Error getting location!, Please try again later')
        this.api.setLocaionErr(true)
      });
    }

    catch (error) {
      this.loader.hideLoader()
    }

  }

  getAddressFromCoords(lattitude, longitude) {
    this.loader.hideLoader()
    console.log("getAddressFromCoords "+lattitude+" "+longitude);
    let options: NativeGeocoderOptions = {
      useLocale: true,
      maxResults: 5    
    }; 
    this.nativeGeocoder.reverseGeocode(lattitude, longitude, options)
      .then((result: NativeGeocoderResult[]) => {
        this.address = "";
        let responseAddress = [];
        for (let [key, value] of Object.entries(result[0])) {
          if(value.length>0)
          responseAddress.push(value); 
        }
        responseAddress.reverse();
        for (let value of responseAddress) {
          this.address += value+", ";
        }
        this.address = this.address.slice(0, -2);
        this.api.setaddress(this.address)
      })
      .catch((error: any) =>{ 
        this.loader.hideLoader()
        this.address = "Address Not Available!";
        this.alert.presentAlert('Alert','','Address Not Available!')
      }); 
  }

}
